export class ConnectionRequest {
  connectToServer: string;

  constructor() {}
}
